import getStore from '../store/store';
import type { QuickStepItem } from 'owa-quick-step-types';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

export function getQuickSteps(mailboxInfo: MailboxInfo): QuickStepItem[] {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return getStore().quickStepsStoreMap.get(accountKey)?.quickSteps ?? [];
}
